<template>
  <v-window v-model="step" touchless>
    <v-window-item :value="1">
      <div class="routes">
        <v-container>
          <v-card flat>
            <v-card-title primary-title>
              <h1>Rutas</h1>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                  <v-btn slot="activator" color="blue-grey darken-2 white--text" dark class="mb-2">Nueva Ruta</v-btn>
                  <v-form v-model="valid" @submit="createRoute" ref="createRouteForm" onSubmit="return false;">
                    <v-card>
                      <v-card-title primary-title>
                        <h1>Nueva Ruta</h1>
                      </v-card-title>
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field
                                name="routeDescription"
                                label="Destino"
                                id="route-description"
                                solo
                                v-model="editedRoute.description"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                v-model="editedRoute.user_id"
                                :items="drivers"
                                item-text="name"
                                item-value="id"
                                hide-no-data
                                hide-details
                                label="Agente"
                                solo
                                ref="driversSelect"
                                required
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                        <v-btn type="submit" color="blue-grey darken-2 white--text" :disabled="!valid">Guardar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-form>
              </v-dialog>
            </v-card-title>
            <v-card-text>
              <v-list two-line subheader
                  v-for="route in routes"
                  :key="route.id">
                <v-list-tile
                  avatar
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ route.description }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ route.created_on | formatDate }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>Agente: {{ route.name }}</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action @click="selectRoute(route)">
                    <v-btn icon ripple>
                      <v-icon color="green">keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
              </v-list>
            </v-card-text>
          </v-card>
        </v-container>
      </div>
    </v-window-item>
    <v-window-item :value="2">
      <route-route :selectedRoute="selectedRoute" @set-step="setStep" v-on:updated-info="onUpdatedRoute" @route-close="loadData"/>
    </v-window-item>
  </v-window>
</template>
<script>

import {getDrivers} from '../services/drivers';
import { createRoute, getOpenRoutes } from '../services/route';

export default {
  data() {
    return {
      step: 1,
      routes: [],
      dialog: false,
      valid: false,
      drivers: [],
      selectedDriver: null,
      routeDescription: null,
      editedRoute: {},
      defaultRoute: {
        user_id: null,
        description: null,
      },
      selectedRoute: {},
    };
  },
  methods: {

    async onUpdatedRoute(routeId) {
      this.step = 1;
    },
    createRoute() {
      createRoute(this.editedRoute)
      .then( (result) => {
        this.dialog = false;
        this.editedRoute = Object.assign({}, this.defaultRoute);
        this.routes.push(result.data);
      });
    },
    close() {
      this.dialog = false;
      this.valid = false;
      this.editedRoute = Object.assign({}, this.defaultRoute);
    },
    selectRoute(route) {
      this.step = 2;
      this.selectedRoute = Object.assign({}, route);
    },
    setStep(step) {
      this.step = step;
    },
    loadData() {
      this.editedRoute = Object.assign({}, this.defaultRoute);
      getOpenRoutes()
        .then( (result) => {
          this.routes = result.data;
        });
      this.step = 1;
    },
  },
  mounted() {
    this.loadData();
    getDrivers()
      .then( (response) => {
        this.drivers = response.data;
      });
  },
};
</script>